/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const dataTable = [
  {
    id: 1,
    stt: "1",
    code: "[04]",
    asset: "Doanh thu từ hoạt động chuyển nhượng bất động sản",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 2,
    stt: "2",
    code: "[05]",
    asset: "Chi phí từ hoạt động chuyển nhượng bất động sản",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 3,
    stt: "",
    code: "[06]",
    asset: "- Giá đất của vốn chuyển nhượng",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 4,
    stt: "",
    code: "[07]",
    asset: "- Chi phí đền bù thiệt hại về đất",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 5,
    stt: "",
    code: "[08]",
    asset: "- Chi phí đền bù thiệt hại về hoa màu",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 6,
    stt: "",
    code: "[09]",
    asset: "- Chi phí cải tạo san lấp mặt bằng",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 7,
    stt: "",
    code: "[10]",
    asset: "- Chi phí đầu tư xây dựng kết cấu hạ tầng",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 8,
    stt: "",
    code: "[11]",
    asset: "- Chi phí khác",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 9,
    stt: "3",
    code: "[12]",
    asset: "Thu nhập từ hoạt động chuyển nhượng bất động sản đã bàn giao trong kỳ ([12]=[04]-[05])",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
  {
    id: 10,
    stt: "",
    code: "[13]",
    asset:
      "- Trong đó: thu nhập từ thực hiện dự án đầu tư - kinh doanh nhà ở xã hội để bán, cho thuê, cho thuê mua được hưởng ưu đãi",
    assetBold: false,
    sttBold: false,
    codeBold: true,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { money: 0 },
  },
];

export default function Table11({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>STT</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.codeBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.code}
                  </Td>

                  <>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.readOnly === true ? "bold" : 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="money"
                        readOnlyBackground={rows.readOnly}
                        readOnly={rows.readOnly}
                        value={rows.value.money}
                        onChange={handleChange}
                        fontWeight={rows.valueBold}
                      />
                    </Td>
                  </>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
